import './solepower/style';
import FormStructure from './solepower/form_structure';

export default FormStructure;